<section class="bg-white divider">
	<div class="flex flex-col">
		<div class="relative overflow-hidden">
			<uc-engage-card-cta-img backgroundImageClass="bg-cta-call-uni" />
			<div class="relative pt-6 mx-auto md:py-12 max-w-7xl">
				<div class="lg:px-5 md:ml-auto md:w-1/2 md:pl-8 lg:pl-16">
					<div class="flex items-center gap-3">
						<img
							width="20"
							height="20"
							alt=""
							[ngSrc]="'/assets/img/call_uni_cta_icon.svg' | cdn"
						/>
						<p class="font-semibold text-gray-500 uppercase">
							Contact to get placed
						</p>
					</div>
					<p class="mt-2 text-2xl font-bold tracking-tight md:text-3xl">
						Call this University
					</p>
					<p class="mt-4 mb-8 text-base text-gray-500">
						Quick call universities you are interested in and gain all the
						info you need to secure your spot on a Clearing
						{{ currentClearingYear }} course.
					</p>
					<uc-call-uni-btn
						buttonText="Call University"
						mobileButtonText="Call University"
						[phoneNumber]="phoneNumber()"
						customStyles="w-full md:w-auto"
						[uniId]="uniId()"
						[uniName]="uniName()"
						[source]="source()"
						[sourceType]="sourceType()"
						componentName="Call University CTA"
						[cleSearchOrderPosition]="cleSearchOrderPosition()"
						data-cy="call-uni-cta-btn"
					/>
				</div>
			</div>
		</div>
	</div>
</section>
